import { Breadcrumb, Button, Col, Form, Image, Input, Radio, Row, Select, Steps, Tooltip } from "antd";
import { _adr } from "../../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { useNavigate } from "react-router-dom";
import "../sp.scss";
import "./profile.scss";
import DatePicker from "../../../auxiliary/datepicker/datepicker";
import { useEffect, useRef, useState } from "react";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import { convertPersian, fileToBase64, fileToformData, regexFormater, validateInput } from "../../../../tools/tools";
import OTP from "../../../auxiliary/otp-modal/otp";
import Loading from "../../../auxiliary/loader/loading";
import { useDispatch, useSelector } from "react-redux";
import { simcardPurchase } from "../../../../reducer/serviceReducer";
import ReactInputMask from "react-input-mask";
import SPShopLayout from "../sp-shop-layout";
import ResizeImage from "../../../auxiliary/resizeImg/resizeImage";
import { CheckTokenWithOTP, Roles, setTokenOTP, switchPlanID } from "../../../../tools/services";
import Iinput from "../../../auxiliary/inputs/Input";

const SPProfile = () => {
	//================ Hook =========================
	const [t] = useTranslation("global");
	const nav = useNavigate();
	const [frmProfile] = Form.useForm();
	const { queryGender, queryActiveProvince, queryCityByCityId, queryActiveCityByProvinceId, addDocument } = useAPIPublic();
	const { queryCountSimCardByCertNo, queryProfileByCertNoVBirthDate, addressByPostcode, addProfile, addAddress } = useDealer();
	const refMsisdn = useRef();
	const [valMsisdn, setValMsisdn] = useState("");
	const formData = useSelector((state) => state?.from?.spPurchase);
	const { _currentUser } = useSelector((state) => {
		return state?.another;
	});
	const dispatch = useDispatch();

	//================ Hook =========================

	//================ State =========================

	//#region Initial Data Set Form =================
	const [initialData, setInitialData] = useState({
		gender: [],
		counterSim: "-1",
		firstSimCard: false,
		province: [],
		city: [],
	});
	useEffect(() => {
		const callServInitial = async () => {
			//Call Service Gender
			if (initialData.gender.length === 0) {
				let resGender = await queryGender();
				if (resGender) {
					setInitialData((prev) => ({ ...prev, gender: resGender }));
				}
			}
			if (initialData.province.length === 0) {
				//Call Service Province
				let resProvince = await queryActiveProvince();
				if (resProvince) {
					setInitialData((prev) => ({ ...prev, province: resProvince }));
				}
			}
		};
		callServInitial();
	}, []);
	//#endregion Initial Data Set Form =================

	//#region Load Data Draft From Reducer ===========

	useEffect(() => {
		if (formData?.profile) {
			handleCityListByProvinceId(formData?.profile?.provinceid);
			frmProfile.setFieldsValue({
				certno: formData?.profile?.certno,
				birthdate: formData?.profile?.birthdate,
				fname: formData?.profile?.fname,
				lname: formData?.profile?.lname,
				fathername: formData?.profile?.fathername,
				gender: formData?.profile?.gender,
				identityno: formData?.profile?.identityno,
				smsmobileno: formData?.profile?.smsmobileno,
				typeforupload: formData?.profile?.typeforupload,
				postalcode: formData?.profile?.postalcode,
				provinceid: formData?.profile?.provinceid,
				cityid: formData?.profile?.cityid,
				tel: formData?.profile?.tel,
				mainstreet: formData?.profile?.mainstreet,
				alley: formData?.profile?.alley,
				auxiliaryroad: formData?.profile?.auxiliaryroad,
				buildingno: formData?.profile?.buildingno,
				floor: formData?.profile?.floor,
				photo: formData?.profile?.photo,
				unit: formData?.profile?.unit,
			});
			setValMsisdn(formData?.profile?.smsmobileno);
		}
	}, [formData]);
	//#endregion Load Data Draft From Reducer ===========

	//#region Check Counter Sim card Activated =======

	const handleCountSim = async (e) => {
		setServProfile((prev) => ({ ...prev, certNo: e.target.value }));
		if (e.target.value.length === 10 && e.target.value !== servProfile?.prevCertNo) {
			let payload = {
				certno: e.target.value,
			};
			let response = await queryCountSimCardByCertNo(payload);
			if (response != null) {
				setServProfile((prev) => ({ ...prev, prevCertNo: e.target.value }));
				if (response === 0) {
					setInitialData((prev) => ({
						...prev,
						firstSimCard: true,
						counterSim: response,
					}));
				} else {
					setInitialData((prev) => ({ ...prev, counterSim: response }));
				}
			}
		}
	};
	//#endregion Check Counter Sim card Activated =======

	//#region Call Service get all Cities From Province
	const handleCityListByProvinceId = async (item) => {
		let resCity = await queryActiveCityByProvinceId(item);
		if (resCity) {
			setInitialData((prev) => ({ ...prev, city: resCity }));
		}
	};
	//#endregion Call Service get all Cities From Province

	//#region callBack Function From Date picker ======
	const handleGetDate = (temp) => {
		frmProfile.setFieldValue("birthdate", temp);
		setServProfile((prev) => ({ ...prev, birtday: temp }));
	};
	//#endregion callBack Function From Date picker ======

	//#region Get Address From Service Post ===========
	//state postalCode ID
	const [postalCodeServ, setPostalCodeServ] = useState({
		postCode: "",
		prevCode: "",
	});
	//Call Service Read Postalcode From Service
	useEffect(() => {
		const CallPostalCode = async () => {
			if (postalCodeServ.postCode.length === 10 && postalCodeServ.postCode !== postalCodeServ.prevCode) {
				let payload = {
					postCode: frmProfile.getFieldValue("postalcode"),
				};
				let resPost = await addressByPostcode(payload);
				if (resPost) {
					setPostalCodeServ((prev) => ({
						...prev,
						prevCode: postalCodeServ.postCode,
					}));
					frmProfile.setFieldsValue({
						mainstreet: resPost?.mainStreet,
						buildingno: resPost?.buildingNo,
						floor: resPost?.floor,
						alley: resPost?.alley,
						auxiliaryroad: resPost?.auxiliaryRoad,
						tel: resPost?.tel,
					});
					if (resPost?.cityId) {
						let resProvince = await queryCityByCityId(resPost?.cityId);
						if (resProvince) {
							frmProfile.setFieldsValue({
								provinceid: resProvince?.provinceid,
							});
							handleCityListByProvinceId(resProvince?.provinceid);
						}
					}
				}
			}
		};
		CallPostalCode();
	}, [postalCodeServ.postCode]);
	//#endregion Get Address From Service Post ===========

	//#region Load Profile With Service ==============
	const [servProfile, setServProfile] = useState({
		birtday: "",
		prevBirtday: "",
		certNo: "",
		prevCertNo: "",
	});
	useEffect(() => {
		const handleReadProfile = async () => {
			if (servProfile.certNo.length === 10 && servProfile.birtday.length > 0) {
				if (servProfile.birtday !== servProfile.prevBirtday || servProfile.certNo !== servProfile.prevCertNo) {
					let payload = {
						certno: servProfile.certNo,
						birthdate: servProfile.birtday,
					};
					let response = await queryProfileByCertNoVBirthDate(payload);
					if (response) {
						setServProfile((prev) => ({
							...prev,
							prevBirtday: servProfile.birtday,
							prevCertNo: servProfile.certNo,
						}));
						frmProfile.setFieldsValue({
							fname: response?.fname,
							lname: response?.lname,
							fathername: response?.fathername,
							gender: response?.gender,
							identityno: response?.identityno,
							smsmobileno: response?.smsmobileno.toString().replace("9", ""),
						});
						setValMsisdn("09" + response?.smsmobileno.toString().replace("9", ""));
						// document.getElementById("refMsisdn")?.value = response?.smsmobileno.toString().replace("9", "");
						if (response?.address?.postalcode?.length > 0) {
							frmProfile.setFieldValue("postalcode", response?.address?.postalcode);
							setPostalCodeServ((prev) => ({
								...prev,
								postCode: response?.address?.postalcode,
							}));
						}
					}
				}
			}
		};
		handleReadProfile();
	}, [servProfile.certNo, servProfile.birtday]);
	//#endregion Load Profile With Service ===========

	useEffect(() => {
		frmProfile.setFieldValue("smsmobileno", valMsisdn);
	}, [valMsisdn]);

	//Show Loader in Page
	const [isOpenOtp, setIsOpenOtp] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isProgress, setisProgress] = useState(false);
	//show Loader in Loading

	//#region submit Form Profile , Address and Document
	const handleSubmit = async (e) => {
		try {
			let _valid = await frmProfile.validateFields();
			if (!_valid.errorFields > 0) {
				//document Photo
				setIsLoading(true);
				setisProgress(true);

				let resDoc = await addDocument(await fileToformData(_valid.photo), _valid.typeforupload);
				if (resDoc) {
					let payload = {
						fname: _valid.fname,
						lname: _valid.lname,
						fathername: _valid.fathername,
						identityno: _valid.identityno,
						certno: _valid.certno,
						birthdate: _valid.birthdate.replace(/\//g, "-"),
						gender: _valid.gender,
						smsmobileno: regexFormater(_valid.smsmobileno).removeSpace(),
						profiletype: 23,
						nationality: "",
						documentid: resDoc.Result,
					};
					setValMsisdn(payload.smsmobileno);
					let resProfile = await addProfile(payload);
					if (resProfile) {
						payload = {
							profileid: resProfile.profileId,
							addresstype: 0,
							addressmodel: {
								cityid: _valid.cityid,
								mainstreet: _valid.mainstreet,
								auxiliaryroad: _valid.auxiliaryroad,
								alley: _valid.alley,
								buildingno: _valid.buildingno,
								floor: _valid.floor,
								postalcode: _valid.postalcode,
								tel: _valid.tel,
								unit: _valid.unit,
							},
						};
						let resAddress = await addAddress(payload);
						if (resAddress && !resAddress.HasError) {
							payload.addresstype = 1;
							let resAgainAddress = await addAddress(payload);
							if (resAgainAddress && !resAgainAddress.HasError) {
								setIsOpenOtp(true);
							}
						}
					}
				}

				setIsLoading(false);
				setisProgress(false);
			}
		} catch (error) {
			setIsLoading(false);
			setisProgress(false);
			console.error(error);
		}
	};
	//#endregion submit Form Profile , Address and Document

	//handle Change Type Upload File Document
	const handleChangeTypeDocument = (e) => {
		frmProfile.setFieldValue("typeforupload", e.target.value);
	};

	//handle Get Token From OTP Service
	const handleGetToken = async (token) => {
		setIsOpenOtp(false);
		if (token) {
			// await setToken({
			//   token: token.token,
			//   expireUTCTime: token.expireUTCTime,
			// });
			// setAuthorization(token.token);
			await setTokenOTP({ expireUTCTime: token.expireUTCTime, token: token.token });
			const isTokenOTP = await CheckTokenWithOTP();
			if (isTokenOTP) {
				let txtGender = initialData?.gender.find((item) => item.value === frmProfile.getFieldValue("gender"))?.name;
				let txtProvince = initialData?.province.find((item) => item.inT__ProvinceId === frmProfile.getFieldValue("provinceid"))?.stR_ProvinceName;
				let txtCity = initialData?.city.find((item) => item.inT_CityId === frmProfile.getFieldValue("cityid"))?.stR_CityName;
				const profileValues = frmProfile.getFieldsValue();
				const photoBase64 = await fileToBase64(profileValues.photo);
				dispatch(
					simcardPurchase({
						spPurchase: {
							...formData,
							token: token.token,
							profile: {
								...profileValues,
								photo: photoBase64,
								txtGender: txtGender,
								txtProvince: txtProvince,
								txtCity: txtCity,
							},
						},
					}),
				);
				nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.PreFactor);
			}
		} else {
		}
	};
	//==========================================

	const handleGetImage = async (value) => {
		frmProfile.setFieldValue("photo", value);
	};

	return (
		<>
			<SPShopLayout>
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.global.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardpurchase.global.title")}</h3>
						<p>{t("simcardpurchase.global.decription")}</p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={2}
											responsive
											items={[
												{
													title: "بسته آغازین",
													data_title: "بسته",
												},
												{
													title: "انتخاب شماره",
													data_title: "بسته",
												},
												{
													title: "اطلاعات هویتی",
													data_title: "بسته",
												},
												{
													title: "پیش فاکتور",
													data_title: "بسته",
												},
												{
													title: "سند",
													data_title: "بسته",
												},
											]}
										/>
									</div>
								</div>
								<div className="holder-form-group">
									<h3 className="header-of-form">اطلاعات هویتی </h3>
									<div className="holder-form">
										<Form form={frmProfile} name="frmProfile" layout="vertical" autoComplete="off">
											<Row gutter={30}>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="certno"
														label="کدملی"
														rules={[
															validateInput({
																t: t,
																validate: true,
																length: 10,
															}),
														]}
														extra={
															<>
																{initialData.counterSim != -1 && (
																	<span className="holder-result">
																		شما میتوانید <span>{10 - initialData.counterSim}</span> سیمکارت دیگر خریداری کنید{" "}
																	</span>
																)}
															</>
														}>
														<Iinput
															maxLength={10}
															inputMode="numeric"
															dir="ltr"
															onBlur={(e) => {
																handleCountSim(e);
															}}
															placeholder="کدملی خود را وارد کنید"
														/>
													</Form.Item>
												</Col>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item className="input-normal" name="birthdate" rules={[validateInput({ t: t, validate: true })]} label="تاریخ تولد">
														<DatePicker values={frmProfile.getFieldValue("birthdate")} onChange={handleGetDate} />
													</Form.Item>
												</Col>
											</Row>
											<Row gutter={30}>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="fname"
														label="نام"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "persian",
															}),
														]}>
														<Iinput />
													</Form.Item>
												</Col>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="lname"
														label="نام خانوادگی"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "persian",
															}),
														]}>
														<Iinput />
													</Form.Item>
												</Col>
											</Row>
											<Row gutter={30}>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="fathername"
														label="نام پدر"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "persian",
															}),
														]}>
														<Iinput />
													</Form.Item>
												</Col>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item className="input-normal" name="gender" label="جنسیت" rules={[validateInput({ t: t, validate: true })]}>
														<Select>
															{initialData?.gender.map((item, key) => (
																<Select.Option key={key} value={item.value}>
																	{item.name}
																</Select.Option>
															))}
														</Select>
													</Form.Item>
												</Col>
											</Row>
											<Row gutter={30}>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="identityno"
														label="شماره شناسنامه"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "number",
															}),
														]}>
														<Iinput dir="ltr" inputMode="numeric" />
													</Form.Item>
												</Col>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="smsmobileno"
														label={initialData?.firstSimCard ? "شماره معرف" : "شماره همراه"}
														extra={!initialData?.firstSimCard && <small>شماره‌همراه دیگری به نام شما</small>}
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "msisdnOrg",
															}),
														]}>
														<div>
															<ReactInputMask
																mask="0\999 99 99 999"
																id="refMsisdn"
																value={frmProfile.getFieldValue("smsmobileno")?.length > 0 ? frmProfile.getFieldValue("smsmobileno") : ""}
																onChange={(e) => {
																	e.target.value = convertPersian(e.target.value);
																	setValMsisdn(e.target.value);
																}}
																className="msisdn-mask"
																dir="ltr"
															/>
														</div>
													</Form.Item>
												</Col>
											</Row>
											<Row gutter={30}>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item name="typeforupload" initialValue={"CertNoCard"} className="input-normal">
														<Radio.Group value={"CertNoCard"} onChange={handleChangeTypeDocument}>
															<Radio value="CertNoCard">تصویرکارت ملی یا شناسنامه جدید</Radio>
															{_currentUser?.roles?.includes(Roles.Dealer_RegisterSim_B2C_UploadPassportDoc) && (
																<Radio value="Passport">تصویر پاسپورت</Radio>
															)}
														</Radio.Group>
													</Form.Item>
												</Col>
											</Row>
											<Row gutter={30}>
												<Col xs={24} sm={12} md={24} lg={12} xl={10}>
													<Form.Item name="photo" rules={[validateInput({ t: t, validate: true })]} label="تصویر مدرک">
														<ResizeImage exportImage={handleGetImage} />
													</Form.Item>
												</Col>
												{/* <Col span={9} style={{ margin: "auto 0" }}>
                          <ul>
                            <li>بارگذاری کارت ملی جدید یا شناسنامه جدید یا کارت ملی قدیمی همراه با رسید کارت ملی جدید</li>
                            <li>فرمت ها و حجم و رزولوشن قابل قبول</li>
                            <li>توضیح در مورد مشخص بودن گوشه های تصویر مدارک</li>
                          </ul>
                        </Col> */}
											</Row>

											<h3>اطلاعات آدرس </h3>
											<Row gutter={30}>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="postalcode"
														label="کدپستی"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "number",
																length: 10,
															}),
														]}>
														<Iinput
															onBlur={(e) => {
																setPostalCodeServ((prev) => ({
																	...prev,
																	postCode: e.target.value,
																}));
															}}
															dir="ltr"
															maxLength={10}
															inputMode="numeric"
															placeholder="کدپستی خود را وارد کنید"
														/>
													</Form.Item>
												</Col>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item className="input-normal" name="provinceid" label="استان" rules={[validateInput({ t: t, validate: true })]}>
														<Select
															filterOption={(inputValue, option) => {
																return option.children.toString().startsWith(inputValue.toString());
															}}
															onChange={(item, option) => {
																handleCityListByProvinceId(item);
															}}
															showSearch>
															{initialData.province.map((item) => (
																<Select.Option key={item.inT__ProvinceId} value={item.inT__ProvinceId}>
																	{item.stR_ProvinceName}
																</Select.Option>
															))}
														</Select>
													</Form.Item>
												</Col>
											</Row>
											<Row gutter={30}>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item className="input-normal" name="cityid" label="شهر" rules={[validateInput({ t: t, validate: true })]}>
														<Select
															filterOption={(inputValue, option) => {
																return option.children.toString().startsWith(inputValue.toString());
															}}
															showSearch>
															{initialData?.city.map((item, key) => (
																<Select.Option key={key} value={item.inT_CityId}>
																	{item.stR_CityName}
																</Select.Option>
															))}
														</Select>
													</Form.Item>
												</Col>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="tel"
														label="تلفن"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "number",
															}),
														]}>
														<Iinput placeholder="تلفن" inputMode="numeric" dir="ltr" />
													</Form.Item>
												</Col>
											</Row>
											<Row gutter={30}>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="mainstreet"
														label="خیابان اصلی"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "persian",
															}),
														]}>
														<Iinput placeholder="خیابان اصلی" />
													</Form.Item>
												</Col>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="alley"
														label="کوچه"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "persian",
															}),
														]}>
														<Iinput placeholder="کوچه" />
													</Form.Item>
												</Col>
											</Row>
											<Row gutter={30}>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="auxiliaryroad"
														label="خیابان فرعی"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "persian",
															}),
														]}>
														<Iinput placeholder="خیابان فرعی" />
													</Form.Item>
												</Col>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="buildingno"
														label="پلاک"
														rules={[
															validateInput({
																t: t,
																validate: true,
																type: "number",
															}),
														]}>
														<Iinput placeholder="پلاک" inputMode="numeric" />
													</Form.Item>
												</Col>
											</Row>
											<Row gutter={30}>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="floor"
														label="طبقه"
														rules={[validateInput({ t: t, validate: true, type: "number" })]}>
														<Iinput placeholder="طبقه" />
													</Form.Item>
												</Col>
												<Col xs={24} sm={12} md={12} lg={10} xl={8}>
													<Form.Item
														className="input-normal"
														name="unit"
														label="واحد"
														rules={[validateInput({ t: t, validate: true, type: "number" })]}>
														<Iinput placeholder="واحد" />
													</Form.Item>
												</Col>
											</Row>
										</Form>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmit} disabled={isProgress}>
										مرحله بعد
									</Button>
									<Button
										type="default"
										className="btn-normal "
										onClick={() => {
											nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Kit);
										}}>
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
				<OTP
					isOpen={isOpenOtp}
					planid={switchPlanID().simPurchase}
					callback={handleGetToken}
					certno={frmProfile.getFieldValue("certno")}
					expiretimebyminute={process.env.REACT_APP_LOGIN_EXPIRE}
					msisdn={valMsisdn?.length > 0 ? valMsisdn?.slice(1) : ""}
					sessionid={Date.now()}
					address={_adr.Root + _adr.SimCardPurchase.Index + _adr.PreFactor}
				/>
				<Loading isOpen={isLoading} />
			</SPShopLayout>
		</>
	);
};

export default SPProfile;
